declare namespace $ {

	type $mol_view__sub_bog_ui_badge_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_badge extends $mol_view {
		Label( ): $mol_view
		label( ): string
		type( ): string
		sub( ): readonly(any)[]
		attr( ): ({ 
			'bog_ui_badge_type': ReturnType< $bog_ui_badge['type'] >,
		}) 
	}
	
}

//# sourceMappingURL=badge.view.tree.d.ts.map